module.exports = __webpack_public_path__ + "static/cannon_static-0c3446db964fc719ef6cece44a9a07f7.png";